

















import {
  Vue,
  Component
} from "@/shared/vuepack";

@Component
export default class GenericLoadingSpinner extends Vue {}

